import React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from "react-router-dom"
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { useSelector } from 'react-redux';
import { currencyFormat } from '../../../helpers/numericFields';
import { Card, Col, Row } from 'react-bootstrap';


export const RoomingTable = () => {
  const { roomingList } = useSelector((state) => state.groupFiles);
  const { roomingList: roomingList2 } = roomingList;

  const columns = [
    {
      name: "Habitacion",
      width: "85px",
      cell: row => <span className="fs-15 fw-semibold text-center w-100">{row.roomNum}</span>
    },
    {
      name: "Expediente",
      width: "85px",
      cell: row => <span className="text-center w-100">
        <OverlayTrigger placement="top" overlay={<Tooltip >Ver Expediente</Tooltip>}>
          <Link to={`/panel/expedienteIndividual?id=${row.file}`}
            className="btn btn-primary btn-sm rounded-11 me-2" ><span className="fs-15 fw-semibold text-center">{row.file}</span></Link>
        </OverlayTrigger>
      </span>
    },
    {
      name: "Fecha",
      selector: row => [row.requestDate],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold text-center">{row.requestDate}</span>
    },
    {
      name: "Cliente",
      selector: row => [row.customer],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold text-center">{row.customer}</span>
    },
    {
      name: "Movil",
      selector: row => [row.cellphone],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold text-center">{row.cellphone}</span>
    },
    {
      name: "Cantidad",
      sortable: false,
      cell: row => <span className="text-muted fs-15 fw-semibold text-center w-100">{row.quantity}</span>
    },
    {
      name: "Habitacion",
      selector: row => [row.occupancy, row.roomCategory, row.hotel],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold text-center">{row.occupancy} {row.roomCategory}, {row.hotel}</span>
    },
    {
      name: "Noches",
      sortable: false,
      cell: row => <span className="text-muted fs-15 fw-semibold text-center w-100">{row.nights}</span>
    },
    {
      name: "Pasajeros",
      sortable: false,
      cell: row => <span className="text-muted fs-15 fw-semibold text-center w-100">{row.passengers}</span>
    },
  ]
  const tableDatas = {
    columns,
    data: roomingList2,
  };
  return (
    <Row>
      <Col sm={12} className="col-12">
        <Card>
          <Card.Header>
            <h3 className="card-title mb-0">Habitaciones</h3>
          </Card.Header>
          <Card.Body>
            <div className="dataTable">
              <div className="table-responsive">
                <DataTableExtensions {...tableDatas} >
                  <DataTable
                    columns={columns}
                    data={roomingList2}
                    noHeader
                    defaultSortField="id"
                    defaultSortAsc={false}
                    striped={true}
                    center={true}
                    persistTableHead
                    pagination
                    highlightOnHover />
                </DataTableExtensions>
              </div>
            </div>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  )
}